module.exports = __webpack_public_path__ + "static/media/Close.20e7647a.svg";